import Vue from 'vue';
// TODO
// export type ProjectState = {
//   board: {
//     avatar: string,
//     key: string,
//     title: string,
//     id: number,
//     targets: Array<Target>
//   }
// }

export type ProjectState = any

export type Target = {
  title: string
  login?: string | undefined
  id: number
}

export type FlowSettingsController = {
  renameFlow: (args: {title: string, key: string}) => Promise<void>
  flowMainHelpMessage: typeof Vue
  startTesting: () => void
}

export enum EditorViewMode {
  Statistics,
  Editor
}

export enum FlowStatValueType {
  Fixed = 'fixed',
  Percent = 'percent',
}

export enum FlowStatisticsMode {
  Users = 'users',
  Steps = 'steps',
  User = 'user'
}
